import { createSelector } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IAuthState } from './auth.state';

const selectAuth = (state: IAppState) => state.auth;
export const getAuthReqError = createSelector(
  selectAuth,
  (state: IAuthState) => state.errors
);
export const selectIsAuth = createSelector(
  selectAuth,
  (state: IAuthState) => state.isAuth
);
export const selectCurrentUserId = createSelector(
  selectAuth,
  (state: IAuthState) => state?.user.id
);
export const selectVerifyEmailLoading = createSelector(
  selectAuth,
  (state: IAuthState) => state.loading?.verifyEmail
);
export const getIsValidToken = createSelector(
  selectAuth,
  (state: IAuthState) => state.isValidToken
);
export const getAuthMessage = createSelector(
  selectAuth,
  (state: IAuthState) => state.message
);
export const getUser = createSelector(
  selectAuth,
  (state: IAuthState) => state?.user
);
export const selectLoginLoading = createSelector(
  selectAuth,
  (state: IAuthState) => state.loading?.login
);
export const selectResetPasswordLoading = createSelector(
  selectAuth,
  (state: IAuthState) => state.loading?.resetPassword
);
export const selectUserRoles = createSelector(
  selectAuth,
  (state: IAuthState) => {
    if (state) {
      return {
        isAdmin: state.user.groups?.includes('admins'),
        isStudent: state.user.groups?.includes('students'),
        isTeacher: state.user.groups?.includes('teachers'),
        isSalesAdmin: state.user.groups?.includes('sales_admin'),
        isSalesManager: state.user.groups?.includes('sales_managers'),
        isSuperUser: state.user.is_superuser,
      };
    }

    return state;
  }
);
